module.exports = __webpack_public_path__ + "static/media/baccaret.67aaabc6.jpeg";